import { render, staticRenderFns } from "./MonsterPower.vue?vue&type=template&id=2a75b0e6&lang=pug&"
import script from "./MonsterPower.vue?vue&type=script&lang=ts&"
export * from "./MonsterPower.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports